<template>
  <div>
    <v-card class="main pa-2">
      <v-toolbar dense flat>
        <v-toolbar-title class="body-2 beez-bold">
          User sessions
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            :loading="userSessionLoader"
            flat
            icon
            @click="refreshSessionLoader"
          >
            <v-icon>
              refresh
            </v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            :loading="killAllSessionLoader"
            flat
            icon
            @click="killAllSession"
          >
            <v-icon>
              delete_sweep
            </v-icon>
          </v-btn>
          <span>Kill all User Session (Including the current one)</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-text-field v-model="search" color="secondary" label="Search">
        </v-text-field>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="userSessions"
          :loading="userSessionLoader"
          :pagination.sync="pagination"
          :rows-per-page-items="headerPageItems"
          item-key="userHexId"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.principalName }}</td>
              <td class="text-xs-left">{{ props.item.username }}</td>
              <td class="text-xs-left">{{ props.item.startedAtLocal }}</td>
              <td class="text-xs-left">{{ props.item.isAuthenticated }}</td>
              <td class="text-xs-left">{{ props.item.authType }}</td>
              <td class="text-xs-left">{{ props.item.isCached }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SyncUpFix',
  data() {
    return {
      userSessionLoader: false,
      killAllSessionLoader: false,
      search: '',
      headerPageItems: [5, 10, 25, { text: 'All', value: -1 }],
      pagination: {
        sortBy: 'startedAt',
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headers: [
        { text: 'Principal Name', value: 'principalName' },
        { text: 'User Name', value: 'username' },
        { text: 'Session/Token created At', value: 'startedAt' },
        { text: 'Is Authenticated', value: 'isAuthenticated' },
        { text: 'Login Type', value: 'authType' },
        { text: 'is Cached', value: 'isCached' }
      ]
    }
  },
  computed: {
    ...mapState({
      userSessions: state => state.admin.userSessions
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  watch: {},
  mounted() {
    this.refreshSessionLoader()
  },
  methods: {
    async refreshSessionLoader() {
      this.userSessionLoader = true
      try {
        await this.$store.dispatch('getUserSessions')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to get User sessions',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.userSessionLoader = false
    },
    async killAllSession() {
      this.killAllSessionLoader = true
      try {
        await this.$store.dispatch('killAllSession')
        await this.refreshSessionLoader()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to kill User session',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.killAllSessionLoader = false
    }
  }
}
</script>

<style scoped></style>
